import {
  initEmbla,
  initEmblaThumbs,
  updateCarouselState,
  updateNavState,
} from '../utils/embla';

const tabs = document.querySelectorAll('.paragraph-tabs');

const initTabs = (tab) => {
  const emblaNode = tab.querySelector('.embla');
  const emblaInstance = initEmbla(emblaNode);
  const thumbsInstance = initEmblaThumbs(emblaInstance, emblaNode);

  // Events.
  emblaInstance.on('select', () => {
    const index = emblaInstance.selectedScrollSnap();
    const thumbsIndex = thumbsInstance.selectedScrollSnap();
    if (index !== thumbsIndex) {
      thumbsInstance.scrollTo(index);
    }
    updateCarouselState(emblaInstance, thumbsInstance);
    updateNavState(emblaInstance, emblaNode);
  });

  // Handle initial active slide & nav state.
  updateCarouselState(emblaInstance, thumbsInstance);
  updateNavState(emblaInstance, emblaNode);
};

(() => {
  if (tabs.length) {
    tabs.forEach((tab) => {
      // need to wait for the DOM to update,
      // otherwise the height isn't calculated correctly
      setTimeout(() => initTabs(tab), 100);
    });
  }
})();
